import {
    SET_AUTHENTICATED,
    SET_UNAUTHENTICATED,
    SET_USER
  } from "../actions/types";
  
  const accessToken = localStorage.getItem("accessToken");

  const initialState =  { isLoggedIn: accessToken ? true : false, user: null};
  export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
      case SET_UNAUTHENTICATED:
        return {
          ...state,
          isLoggedIn: false,
          user: null,
        };
        case SET_AUTHENTICATED:
          return {
            ...state,
            isLoggedIn: true,
        };
        case SET_USER:
        return {
          ...state,
          isLoggedIn: true,
          user: { ...state.user, ...payload},
        };
      default:
        return state;
    }
  }